export class ClienteDTO {
  public id = 0;
  public nome = '';
  public email = '';
  public status = '';
  public cnpjOuCpf = '';
}

export class ClienteDTOEmail {
  public nome = '';
  public razaoSocial = '';
  public cpfOuCnpj = '';
  public email = '';
  public telefone = '';
  public celular = '';
  public cep = '';
  public bairro = '';
  public endereco = '';
  public cidade = '';
  public estado = '';
  public numero = '';
  public usuarios: AgenteEmissor[] = [{
    nome: '',
    email: '',
    cpf: '',
    celular: '',
  }]
}

export class AgenteEmissor {
  public nome = '';
  public email = '';
  public cpf = '';
  public celular = '';
}